import Joi from "joi"
import { useContactType } from "../../contexts/ContactContext"
import { FieldType, TextFieldType } from "../fields"
import { useDictionary } from "../../contexts/dictionary"
import { FormComponent } from "../form"
import { useFormHandling } from "../../hooks/formUtils"
import { RequestConfigs } from "../../api"
import { ActionButton } from "../buttons/ActionButton"
import { Col, Text, VImage } from "../../style/base.style"
import { useEffect, useState } from "react"
import { VSuccess } from "../../constants/images"
import { Title } from "@mantine/core"




export const Subscribe = () => {
    const { contact } = useContactType()
    const { translate } = useDictionary()
    const {serverRes,handleClick,handleInputChange} = useFormHandling({ requestType: RequestConfigs.subscribe })

    const [showSuccess,setShowSuccess] = useState<boolean>(false)

    const fields: FieldConfig[] = [
        {
            type: FieldType.text,
            name: "Full_Name",
            label: translate("name"),
            joiSchema: Joi.string().pattern(/^\s*\S+\s+\S+\s*$/).message('Must contain exactly two words').required(),
            typeOptions: {
                type: TextFieldType.text,
            }
        },
        {
            type: FieldType.text,
            name: "Email",
            label: translate("email_label"),
            joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
            typeOptions: {
                type: TextFieldType.text,
            }
        },
    ]

    useEffect(() => {
        if (serverRes?.succeeded) {
            setShowSuccess(true)
        }
    }, [serverRes])
    return (
       
      <>
      {
        !contact && !showSuccess &&

        <>
        <h6 className="footer-title">{translate('newsletter')}</h6>
                    <p className="mb-2">
                      {translate('subscribe_newsletter')}
                    </p>

                    <Col $alignItems="flex-end">
            
          <FormComponent
            fields={fields}
            onChange={handleInputChange}
            serverRes={serverRes}
        />
        <ActionButton
            label={translate("send")}
            onClick={handleClick}
            fontIcon={"feather icon-send"}
        />
        </Col>
        
        </>

        
         
      }

      {
        showSuccess && 
        <Col $alignItems="flex-start" $justifyContent="center">
        <VImage $width="100px" src={VSuccess} />
        <Text>{translate("successfully_registered")}</Text>        
        <br />
        </Col>
      }
      </>
        
    )




}